import React, { useEffect, useRef, useState } from 'react';
import './HomeVideoPlayer.css';

const FIXED_VIDEO = {
  src: '/video.mp4',
  type: 'video/mp4',
};

function formatTime(totalSeconds) {
  if (!Number.isFinite(totalSeconds)) {
    return '0:00';
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60)
    .toString()
    .padStart(2, '0');

  return `${minutes}:${seconds}`;
}

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.68L9.54 5.98A1 1 0 0 0 8 6.82Z" fill="currentColor" />
  </svg>
);

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 5.75A.75.75 0 0 1 7.75 5h2.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 7 18.25V5.75Zm6 0A.75.75 0 0 1 13.75 5h2.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75V5.75Z" fill="currentColor" />
  </svg>
);

const ReplayTenIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 5a7 7 0 1 0 6.93 8h-2.08A5 5 0 1 1 12 7c1.3 0 2.48.5 3.37 1.32L13 10.7h6V5.1l-2.18 2.19A8.94 8.94 0 0 0 12 5Zm-2.4 5.8h1.34v5.47H9.6V10.8Zm2.1 1.2c0-.74.3-1.33.88-1.8.43-.34.98-.52 1.63-.52.75 0 1.34.2 1.76.62.43.41.64.94.64 1.57 0 .47-.12.88-.35 1.24-.16.24-.48.58-.96 1l-1.14 1.01h2.53v1.15h-4.3v-1c.21-.2.58-.54 1.12-1.01.53-.48.89-.82 1.07-1.02.28-.31.43-.63.43-.96 0-.28-.08-.52-.24-.7a.88.88 0 0 0-.68-.27.85.85 0 0 0-.73.34c-.17.23-.26.56-.28.99H11.7v-.64Z" fill="currentColor" />
  </svg>
);

const ForwardTenIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 5c-1.87 0-3.6.57-5.04 1.54L4.78 4.36V10h5.64L8.4 7.98A6.96 6.96 0 0 1 12 7a5 5 0 1 1-4.85 6H5.07A7 7 0 1 0 12 5Zm-.3 7c0-.74.3-1.33.88-1.8.43-.34.98-.52 1.63-.52.75 0 1.34.2 1.76.62.43.41.64.94.64 1.57 0 .47-.12.88-.35 1.24-.16.24-.48.58-.96 1l-1.14 1.01h2.53v1.15h-4.3v-1c.21-.2.58-.54 1.12-1.01.53-.48.89-.82 1.07-1.02.28-.31.43-.63.43-.96 0-.28-.08-.52-.24-.7a.88.88 0 0 0-.68-.27.85.85 0 0 0-.73.34c-.17.23-.26.56-.28.99H11.7v-.64Zm-2.1-1.2h1.34v5.47H9.6V10.8Z" fill="currentColor" />
  </svg>
);

const VolumeIcon = ({ muted }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {muted ? (
      <path d="M14 6.45v11.1a.75.75 0 0 1-1.28.53L8.64 14H5.75A1.75 1.75 0 0 1 4 12.25v-.5C4 10.78 4.78 10 5.75 10h2.89l4.08-4.08A.75.75 0 0 1 14 6.45Zm3.53 3.47L16.47 11l1.06 1.08-1.06 1.06L15.4 12.06l-1.07 1.08-1.06-1.06L14.34 11l-1.07-1.08 1.06-1.06 1.07 1.08 1.07-1.08 1.06 1.06Z" fill="currentColor" />
    ) : (
      <path d="M14 6.45v11.1a.75.75 0 0 1-1.28.53L8.64 14H5.75A1.75 1.75 0 0 1 4 12.25v-.5C4 10.78 4.78 10 5.75 10h2.89l4.08-4.08A.75.75 0 0 1 14 6.45Zm2.46 2.72a.75.75 0 0 1 1.06 0 4.96 4.96 0 0 1 1.48 3.56 4.96 4.96 0 0 1-1.48 3.56.75.75 0 0 1-1.06-1.06c.61-.61 1.04-1.47 1.04-2.5s-.43-1.89-1.04-2.5a.75.75 0 0 1 0-1.06Zm-1.95 1.94a.75.75 0 0 1 1.03.28c.18.31.28.67.28 1.06s-.1.75-.28 1.06a.75.75 0 0 1-1.31-.78c.05-.08.09-.18.09-.28s-.04-.2-.09-.28a.75.75 0 0 1 .28-1.03Z" fill="currentColor" />
    )}
  </svg>
);

const FullscreenIcon = ({ active }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {active ? (
      <path d="M8 4.75A.75.75 0 0 1 8.75 4h3.5a.75.75 0 0 1 0 1.5H9.5v2.75a.75.75 0 0 1-1.5 0v-3.5ZM15.75 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V5.5h-2.75a.75.75 0 0 1 0-1.5h3.5ZM8.75 14.25a.75.75 0 0 1 .75.75v2.75h2.75a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 .75-.75Zm6.5 4.25a.75.75 0 0 1 0-1.5H18V15a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75h-3.5Z" fill="currentColor" />
    ) : (
      <path d="M5.5 9A.75.75 0 0 1 4 9V5.5a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H5.5V9Zm10.25-4.25h3.5a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-1.5 0V6.25h-2.75a.75.75 0 0 1 0-1.5ZM4.75 14.25A.75.75 0 0 1 5.5 15v2.75h2.75a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 .75-.75Zm14.5 0A.75.75 0 0 1 20 15v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5h2.75V15a.75.75 0 0 1 .75-.75Z" fill="currentColor" />
    )}
  </svg>
);

const HomeVideoPlayer = () => {
  const videoRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(document.fullscreenElement === wrapperRef.current);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const togglePlayback = async () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    if (video.paused) {
      try {
        await video.play();
      } catch (_) {
        setIsPlaying(false);
      }
      return;
    }

    video.pause();
  };

  const skipBy = (seconds) => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    const nextTime = Math.min(Math.max(video.currentTime + seconds, 0), duration || video.duration || 0);
    video.currentTime = nextTime;
    setCurrentTime(nextTime);
  };

  const handleVolumeChange = (event) => {
    const nextVolume = Number(event.target.value);
    const video = videoRef.current;

    setVolume(nextVolume);
    setIsMuted(nextVolume === 0);

    if (video) {
      video.volume = nextVolume;
      video.muted = nextVolume === 0;
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    const nextMuted = !video.muted;
    video.muted = nextMuted;
    setIsMuted(nextMuted);

    if (!nextMuted && volume === 0) {
      video.volume = 1;
      setVolume(1);
    }
  };

  const toggleFullscreen = async () => {
    const wrapper = wrapperRef.current;
    if (!wrapper) {
      return;
    }

    if (document.fullscreenElement === wrapper) {
      await document.exitFullscreen();
      return;
    }

    try {
      await wrapper.requestFullscreen();
    } catch (_) {}
  };

  const adjustVolumeBy = (delta) => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    const nextVolume = Math.min(Math.max((video.muted ? 0 : video.volume) + delta, 0), 1);
    video.volume = nextVolume;
    video.muted = nextVolume === 0;
    setVolume(nextVolume);
    setIsMuted(nextVolume === 0);
  };

  const handleTimelineChange = (event) => {
    const nextTime = Number(event.target.value);
    const video = videoRef.current;
    if (!video) {
      return;
    }

    video.currentTime = nextTime;
    setCurrentTime(nextTime);
  };

  const handlePlayerKeyDown = (event) => {
    const targetTagName = event.target.tagName;
    const isRangeInput = targetTagName === 'INPUT';

    if (isRangeInput) {
      return;
    }

    switch (event.key) {
      case ' ':
      case 'Spacebar':
        event.preventDefault();
        togglePlayback();
        break;
      case 'ArrowLeft':
        event.preventDefault();
        skipBy(-10);
        break;
      case 'ArrowRight':
        event.preventDefault();
        skipBy(10);
        break;
      case 'ArrowUp':
        event.preventDefault();
        adjustVolumeBy(0.1);
        break;
      case 'ArrowDown':
        event.preventDefault();
        adjustVolumeBy(-0.1);
        break;
      case 'f':
      case 'F':
        event.preventDefault();
        toggleFullscreen();
        break;
      case 'm':
      case 'M':
        event.preventDefault();
        toggleMute();
        break;
      default:
        break;
    }
  };

  return (
    <section className="home-video-section" aria-labelledby="home-video-title">
      <div className="home-video-header">
        <h2 className="home-video-title" id="home-video-title">
          Featured Video
        </h2>
        <p className="home-video-copy">
          This player uses the original file source, so it plays at the exact quality available in the uploaded video.
        </p>
      </div>

      <div
        className="home-video-player"
        ref={wrapperRef}
        tabIndex="0"
        onKeyDown={handlePlayerKeyDown}
        aria-label="Featured video player. Use space to play or pause, left and right arrows to seek, and up and down arrows to adjust volume."
      >
        <video
          ref={videoRef}
          className="home-video-element"
          preload="metadata"
          playsInline
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onLoadedMetadata={(event) => setDuration(event.currentTarget.duration || 0)}
          onTimeUpdate={(event) => setCurrentTime(event.currentTarget.currentTime)}
          onVolumeChange={(event) => {
            setVolume(event.currentTarget.volume);
            setIsMuted(event.currentTarget.muted);
          }}
        >
          <source src={FIXED_VIDEO.src} type={FIXED_VIDEO.type} />
          Your browser does not support HTML5 video playback.
        </video>

        <div className="home-video-controls" role="group" aria-label="Video controls">
          <div className="home-video-progress-row">
            <label className="home-video-range-label" htmlFor="home-video-progress">
              Progress
            </label>
            <input
              id="home-video-progress"
              className="home-video-range"
              type="range"
              min="0"
              max={duration || 0}
              step="0.1"
              value={Math.min(currentTime, duration || 0)}
              onChange={handleTimelineChange}
              aria-valuetext={`${formatTime(currentTime)} of ${formatTime(duration)}`}
            />
            <span className="home-video-time" aria-live="polite">
              {formatTime(currentTime)} / {formatTime(duration)}
            </span>
          </div>

          <div className="home-video-actions-row">
            <div className="home-video-actions-start">
              <button type="button" className="home-video-button" onClick={toggleMute} aria-label={isMuted || volume === 0 ? 'Unmute video' : 'Mute video'}>
                <VolumeIcon muted={isMuted || volume === 0} />
              </button>
              <div className="home-video-range-group home-video-volume-group">
                <label className="home-video-range-label" htmlFor="home-video-volume">
                  Volume
                </label>
                <input
                  id="home-video-volume"
                  className="home-video-range"
                  type="range"
                  min="0"
                  max="1"
                  step="0.05"
                  value={isMuted ? 0 : volume}
                  onChange={handleVolumeChange}
                  aria-valuetext={`Volume ${Math.round((isMuted ? 0 : volume) * 100)} percent`}
                />
              </div>
            </div>

            <div className="home-video-actions-center">
              <button type="button" className="home-video-button" onClick={() => skipBy(-10)} aria-label="Go back 10 seconds">
                <ForwardTenIcon />
              </button>
              <button type="button" className="home-video-button home-video-button-primary" onClick={togglePlayback} aria-label={isPlaying ? 'Pause video' : 'Play video'}>
                {isPlaying ? <PauseIcon /> : <PlayIcon />}
              </button>
              <button type="button" className="home-video-button" onClick={() => skipBy(10)} aria-label="Go forward 10 seconds">
                <ReplayTenIcon />
              </button>
            </div>

            <div className="home-video-actions-end">
              <button type="button" className="home-video-button" onClick={toggleFullscreen} aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}>
                <FullscreenIcon active={isFullscreen} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeVideoPlayer;
